const config = {
  appUser: process.env.REACT_APP_DEV_USER_ID || "*SyRKjuKQCYogGsphzQsrh",
  host: process.env.REACT_APP_API_HOST || "127.0.0.1",
  idpHost: process.env.REACT_APP_IDP_HOST || "immocom.aloapsoftware.com",
};

export default config;
